export const getUserInfo = () => {
    const userDataString = sessionStorage.getItem("userInfo");
    if (!userDataString) return null;            
    const userData = JSON.parse(userDataString);
    return {...userData.user, token:userData.token};
}